var React = require('react');

function OneInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.1142 0.454547H20.0233C18.9324 0.454547 18.1142 0.727274 17.2051 1.27273C13.6596 3.45454 9.3869 5.09091 5.11417 5.63636C3.65962 5.90909 2.93235 6.63637 3.11417 8.18182L3.56871 11.7273C3.75053 13.1818 4.65962 14 6.11417 13.7273C10.2051 13.0909 14.9324 11.4545 17.9324 8.90909C18.296 8.63636 18.5687 8.81818 18.5687 9.27273V57.2727C18.5687 57.6364 18.296 57.8182 18.0233 57.8182H2.75053C1.29599 57.8182 0.477805 58.6364 0.477805 60.0909V62.7273C0.477805 64.1818 1.29599 65 2.75053 65H40.4778C41.9324 65 42.7505 64.1818 42.7505 62.7273V60.0909C42.7505 58.6364 41.9324 57.8182 40.4778 57.8182H26.9324C26.5687 57.8182 26.3869 57.5455 26.3869 57.2727V2.72727C26.3869 1.27273 25.5687 0.454547 24.1142 0.454547Z","fill":"#B1C077"}));
}

OneInline.defaultProps = {"width":"43","height":"65","viewBox":"0 0 43 65","fill":"none"};

module.exports = OneInline;

OneInline.default = OneInline;
